import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export var DownloadCampaignReportExtensionInline;
(function (DownloadCampaignReportExtensionInline) {
    DownloadCampaignReportExtensionInline["PDF"] = "PDF";
    DownloadCampaignReportExtensionInline["XLSX"] = "XLSX";
})(DownloadCampaignReportExtensionInline || (DownloadCampaignReportExtensionInline = {}));
export const getCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startDate : (params.startDate ?? queryDefaults?.['startDate']);
        if (value !== undefined) {
            urlParams.append('startDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.endDate : (params.endDate ?? queryDefaults?.['endDate']);
        if (value !== undefined) {
            urlParams.append('endDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedCampaignIds
            : (params.includedCampaignIds ?? queryDefaults?.['includedCampaignIds']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('includedCampaignIds', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedCampaignPositionIds
            : (params.includedCampaignPositionIds ?? queryDefaults?.['includedCampaignPositionIds']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('includedCampaignPositionIds', item.toString()));
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaigns.paramsOrder = [{ type: 'parameters' }];
export const createCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCampaignById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignById.paramsOrder = [{ type: 'parameters' }];
export const updateCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const runCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/run'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/run'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
runCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const downloadOrderDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.language === undefined) {
        throw new Error('Missing required parameter: language');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/order-document'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/order-document'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.language !== undefined) {
        urlParams.append('language', params.language.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadOrderDocument.paramsOrder = [{ type: 'parameters' }];
export const cloneCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaign.paramsOrder = [{ type: 'parameters' }];
export const addCampaignComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/comments'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/comments'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.commentId !== undefined) {
        urlParams.append('commentId', params.commentId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addCampaignComment.paramsOrder = [{ type: 'parameters' }];
export const removeCampaignComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/comments'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/comments'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.commentId !== undefined) {
        urlParams.append('commentId', params.commentId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeCampaignComment.paramsOrder = [{ type: 'parameters' }];
export const getCampaignCommentEmails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/comments/emails'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/comments/emails'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignCommentEmails.paramsOrder = [{ type: 'parameters' }];
export const getCampaignDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/delivery-data-per-day'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/delivery-data-per-day'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
/** Downloads daily delivery report as xlsx */ export const downloadDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/delivery-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/delivery-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDeliveryReport.paramsOrder = [{ type: 'parameters' }];
/** Downloads daily creative delivery report as xlsx */ export const downloadCreativeDeliveryReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/creative-delivery-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/creative-delivery-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadCreativeDeliveryReport.paramsOrder = [{ type: 'parameters' }];
/** Downloads delivery report per position and website as csv */ export const downloadWebsiteReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/website-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/website-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadWebsiteReport.paramsOrder = [{ type: 'parameters' }];
/** Downloads daily delivery report per position and website as csv */ export const downloadWebsiteDailyReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/website-daily-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/website-daily-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadWebsiteDailyReport.paramsOrder = [{ type: 'parameters' }];
/** Downloads delivery report per device type as csv */ export const downloadDeviceReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/device-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/device-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDeviceReport.paramsOrder = [{ type: 'parameters' }];
/** Generates the campaign report as pdf or xlsx and returns its content */ export const downloadCampaignReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.extension === undefined) {
        throw new Error('Missing required parameter: extension');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/campaign-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/campaign-report/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.extension !== undefined) {
        urlParams.append('extension', params.extension.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadCampaignReport.paramsOrder = [{ type: 'parameters' }];
/** Returns preview html */ export const getHtmlAttachmentPreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/attachment/html'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaigns/{id}/attachment/html'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getHtmlAttachmentPreview.paramsOrder = [{ type: 'parameters' }];
/** Returns campaigns for reporting using keyset pagination */ export const getReportingCampaignsCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-selfbooking/reporting/campaigns/cursor';
    const pathInternal = '/api/reporting/campaigns/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignsCursor.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.state : (params.state ?? queryDefaults?.['state']);
        if (value !== undefined) {
            urlParams.append('state', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startDate : (params.startDate ?? queryDefaults?.['startDate']);
        if (value !== undefined) {
            urlParams.append('startDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.endDate : (params.endDate ?? queryDefaults?.['endDate']);
        if (value !== undefined) {
            urlParams.append('endDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startBefore : (params.startBefore ?? queryDefaults?.['startBefore']);
        if (value !== undefined) {
            urlParams.append('startBefore', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.startAfter : (params.startAfter ?? queryDefaults?.['startAfter']);
        if (value !== undefined) {
            urlParams.append('startAfter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.endsBefore : (params.endsBefore ?? queryDefaults?.['endsBefore']);
        if (value !== undefined) {
            urlParams.append('endsBefore', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.endsAfter : (params.endsAfter ?? queryDefaults?.['endsAfter']);
        if (value !== undefined) {
            urlParams.append('endsAfter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedCampaignIds
            : (params.includedCampaignIds ?? queryDefaults?.['includedCampaignIds']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('includedCampaignIds', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedCampaignPositionIds
            : (params.includedCampaignPositionIds ?? queryDefaults?.['includedCampaignPositionIds']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('includedCampaignPositionIds', item.toString()));
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const createCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaignPosition.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCampaignPositionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionById.paramsOrder = [{ type: 'parameters' }];
export const cloneCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const updateCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignPosition.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateCampaignPositionStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/status'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/status'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignPositionStatus.paramsOrder = [{ type: 'parameters' }];
export const calculateClicksAndImpressions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.industryId === undefined) {
        throw new Error('Missing required parameter: industryId');
    }
    if (params.budget === undefined) {
        throw new Error('Missing required parameter: budget');
    }
    if (params.price === undefined) {
        throw new Error('Missing required parameter: price');
    }
    const path = '/api/ws-selfbooking/campaign-positions/clicks-and-impressions';
    const pathInternal = '/api/campaign-positions/clicks-and-impressions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.industryId !== undefined) {
        urlParams.append('industryId', params.industryId.toString());
    }
    if (params.budget !== undefined) {
        urlParams.append('budget', params.budget.toString());
    }
    if (params.price !== undefined) {
        urlParams.append('price', params.price.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateClicksAndImpressions.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/by-campaign';
    const pathInternal = '/api/campaign-positions/by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByCampaignId.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsByCreativeId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/by-creative';
    const pathInternal = '/api/campaign-positions/by-creative';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeId !== undefined) {
        urlParams.append('creativeId', params.creativeId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByCreativeId.paramsOrder = [{ type: 'parameters' }];
export const getActiveCampaignPositionsByCreativeIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeIds === undefined) {
        throw new Error('Missing required parameter: creativeIds');
    }
    const path = '/api/ws-selfbooking/campaign-positions/active-by-creatives';
    const pathInternal = '/api/campaign-positions/active-by-creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeIds !== undefined) {
        params.creativeIds.forEach((item) => urlParams.append('creativeIds', item.toString()));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getActiveCampaignPositionsByCreativeIds.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/delivery-data-per-day'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/delivery-data-per-day'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionDeliveryDataPerPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/delivery-data-per-publisher'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/delivery-data-per-publisher'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionDeliveryDataPerPublisher.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionDeliveryDataPerCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/delivery-data-per-creative'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/delivery-data-per-creative'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionDeliveryDataPerCreative.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/history';
    const pathInternal = '/api/campaign-positions/history';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    {
        const value = queryDefaults === false
            ? params.campaignPositionId
            : (params.campaignPositionId ?? queryDefaults?.['campaignPositionId']);
        if (value !== undefined) {
            urlParams.append('campaignPositionId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionHistory.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionPriceHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/price-history';
    const pathInternal = '/api/campaign-positions/price-history';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    {
        const value = queryDefaults === false
            ? params.campaignPositionId
            : (params.campaignPositionId ?? queryDefaults?.['campaignPositionId']);
        if (value !== undefined) {
            urlParams.append('campaignPositionId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionPriceHistory.paramsOrder = [{ type: 'parameters' }];
export const linkCreativesToCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaign-positions/link-creatives';
    const pathInternal = '/api/campaign-positions/link-creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false
            ? params.overrideExisting
            : (params.overrideExisting ?? queryDefaults?.['overrideExisting']);
        if (value !== undefined) {
            urlParams.append('overrideExisting', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
linkCreativesToCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns campaign positions for reporting using keyset pagination */ export const getReportingCampaignPositionsCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-selfbooking/reporting/campaign-positions/cursor';
    const pathInternal = '/api/reporting/campaign-positions/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignPositionsCursor.paramsOrder = [{ type: 'parameters' }];
export const getForecastInventory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/forecast/{campaignId}'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/forecast/{campaignId}'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastInventory.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getBudgetSuggestion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/budget-suggestion/{campaignId}'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/budget-suggestion/{campaignId}'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBudgetSuggestion.paramsOrder = [{ type: 'parameters' }];
/** Creates the advertiser of a newly registered promo company and, when the registration carries one, its first creative */ export const createPromoRegistration = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/promo-registrations';
    const pathInternal = '/api/promo-registrations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
createPromoRegistration.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getAdvertisers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/advertisers';
    const pathInternal = '/api/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.industryId : (params.industryId ?? queryDefaults?.['industryId']);
        if (value !== undefined) {
            urlParams.append('industryId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertisers.paramsOrder = [{ type: 'parameters' }];
export const createAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/advertisers';
    const pathInternal = '/api/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdvertiser.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getAdvertiserById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/advertisers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertiserById.paramsOrder = [{ type: 'parameters' }];
export const updateAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/advertisers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdvertiser.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateAdvertiserStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}/status'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/advertisers/{id}/status'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdvertiserStatus.paramsOrder = [{ type: 'parameters' }];
export const getAdvertiserCampaignStat = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}/campaign-stat'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/advertisers/{id}/campaign-stat'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertiserCampaignStat.paramsOrder = [{ type: 'parameters' }];
/** Replace old advertiser id with new one. */ export const replaceAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.oldAdvertiserId === undefined) {
        throw new Error('Missing required parameter: oldAdvertiserId');
    }
    if (params.newAdvertiserId === undefined) {
        throw new Error('Missing required parameter: newAdvertiserId');
    }
    const path = '/api/ws-selfbooking/advertisers/replace-id';
    const pathInternal = '/api/advertisers/replace-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.oldAdvertiserId !== undefined) {
        urlParams.append('oldAdvertiserId', params.oldAdvertiserId.toString());
    }
    if (params.newAdvertiserId !== undefined) {
        urlParams.append('newAdvertiserId', params.newAdvertiserId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAdvertiser.paramsOrder = [{ type: 'parameters' }];
export const getIndustries = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/industries';
    const pathInternal = '/api/industries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getIndustries.paramsOrder = [{ type: 'parameters' }];
/** Returns all conversion trackers by advertiser */ export const getConversionTrackers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/conversion-trackers';
    const pathInternal = '/api/conversion-trackers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.campaignId : (params.campaignId ?? queryDefaults?.['campaignId']);
        if (value !== undefined) {
            urlParams.append('campaignId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackers.paramsOrder = [{ type: 'parameters' }];
/** Create conversion tracker */ export const createConversionTracker = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/conversion-trackers';
    const pathInternal = '/api/conversion-trackers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createConversionTracker.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns conversion tracker by id */ export const getConversionTrackerById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversion-trackers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackerById.paramsOrder = [{ type: 'parameters' }];
/** Update conversion tracker by id */ export const updateConversionTracker = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversion-trackers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateConversionTracker.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns all conversion trackers that match provided ids */ export const getConversionTrackersByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.trackersIds === undefined) {
        throw new Error('Missing required body: trackersIds');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/by-ids';
    const pathInternal = '/api/conversion-trackers/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.trackersIds !== undefined) {
        body = params.trackersIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackersByIds.paramsOrder = [{ type: 'body', paramName: 'trackersIds' }];
/** Returns the instructions on how to implement conversion tracker */ export const downloadConversionTrackerInstruction = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/{id}/instruction'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversion-trackers/{id}/instruction'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
downloadConversionTrackerInstruction.paramsOrder = [{ type: 'parameters' }];
/** Returns all creatives */ export const getCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.flag : (params.flag ?? queryDefaults?.['flag']);
        if (value !== undefined) {
            urlParams.append('flag', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.onlyActive : (params.onlyActive ?? queryDefaults?.['onlyActive']);
        if (value !== undefined) {
            urlParams.append('onlyActive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreatives.paramsOrder = [{ type: 'parameters' }];
/** Create creative */ export const createCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCreative.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Generates creative by a given URL */ export const generateCreativeByUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    if (params.url === undefined) {
        throw new Error('Missing required parameter: url');
    }
    const path = '/api/ws-selfbooking/creatives/generate-by-url';
    const pathInternal = '/api/creatives/generate-by-url';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    if (params.url !== undefined) {
        urlParams.append('url', params.url.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateCreativeByUrl.paramsOrder = [{ type: 'parameters' }];
/** Generates creative texts and the page image from a given URL without persisting anything, for the anonymous yaleo demo page */ export const generateDemoCreativeByUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.url === undefined) {
        throw new Error('Missing required parameter: url');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    const path = '/api/ws-selfbooking/public/creatives/generate-by-url';
    const pathInternal = '/api/public/creatives/generate-by-url';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.url !== undefined) {
        urlParams.append('url', params.url.toString());
    }
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateDemoCreativeByUrl.paramsOrder = [{ type: 'parameters' }];
/** Uploads the image of a demo creative, re-encoded to JPEG, for the promo registration of the anonymous yaleo demo page */ export const uploadDemoCreativeImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/public/creatives/images';
    const pathInternal = '/api/public/creatives/images';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadDemoCreativeImage.paramsOrder = [{ type: 'formData' }];
/** Builds a draft text-to-image prompt from the already filled creative fields, or from the linked article page when no texts are filled yet. Returns an empty prompt when there is nothing to build a draft from (or the draft generation fails), so the dialog always opens. */ export const generateCreativeImagePrompt = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives/generate-image-prompt';
    const pathInternal = '/api/creatives/generate-image-prompt';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateCreativeImagePrompt.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Generates a creative image (16:9) by text prompt using Gemini Nano Banana */ export const generateCreativeImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives/generate-image';
    const pathInternal = '/api/creatives/generate-image';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateCreativeImage.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Clone creative and generate new text */ export const cloneCreativeGenerateNewText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/clone-generate-new-text'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}/clone-generate-new-text'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCreativeGenerateNewText.paramsOrder = [{ type: 'parameters' }];
/** Update creative and generate new text */ export const updateCreativeGenerateNewText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/update-generate-new-text'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}/update-generate-new-text'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativeGenerateNewText.paramsOrder = [{ type: 'parameters' }];
/** Returns creative by id */ export const getCreativeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeById.paramsOrder = [{ type: 'parameters' }];
/** Update creative by id */ export const updateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreative.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete creative by id */ export const deleteCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreative.paramsOrder = [{ type: 'parameters' }];
export const getCreativePreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-selfbooking/creatives/{creativeId}/preview'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/creatives/{creativeId}/preview'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativePreview.paramsOrder = [{ type: 'parameters' }];
export const updateCreativesStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-selfbooking/creatives/status';
    const pathInternal = '/api/creatives/status';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativesStatus.paramsOrder = [{ type: 'body', paramName: 'ids' }, { type: 'parameters' }];
/** Approve creative */ export const approveCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/approve'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}/approve'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approveCreative.paramsOrder = [{ type: 'parameters' }];
/** Returns a default creative rejection message */ export const getCreativeRejectedMessage = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/creatives/reject-message';
    const pathInternal = '/api/creatives/reject-message';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeRejectedMessage.paramsOrder = [];
/** Reject creative */ export const rejectCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/reject'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}/reject'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
rejectCreative.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Clone creative */ export const cloneCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/creatives/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCreative.paramsOrder = [{ type: 'parameters' }];
/** Returns all creatives that match provided ids */ export const getCreativesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-selfbooking/creatives/by-ids';
    const pathInternal = '/api/creatives/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const createSetupIntent = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/pp/setup-intent';
    const pathInternal = '/api/pp/setup-intent';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSetupIntent.paramsOrder = [];
export const succeedSetupIntent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentMethod === undefined) {
        throw new Error('Missing required parameter: paymentMethod');
    }
    const path = '/api/ws-selfbooking/pp/setup-intent';
    const pathInternal = '/api/pp/setup-intent';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.paymentMethod !== undefined) {
        urlParams.append('paymentMethod', params.paymentMethod.toString());
    }
    {
        const value = queryDefaults === false ? params.isDefault : (params.isDefault ?? queryDefaults?.['isDefault']);
        if (value !== undefined) {
            urlParams.append('isDefault', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
succeedSetupIntent.paramsOrder = [{ type: 'parameters' }];
export const getCreditCards = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-selfbooking/credit-cards';
    const pathInternal = '/api/credit-cards';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreditCards.paramsOrder = [{ type: 'parameters' }];
export const deleteCreditCard = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/credit-cards/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/credit-cards/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreditCard.paramsOrder = [{ type: 'parameters' }];
export const updateCreditCardAsDefault = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/credit-cards/{id}/set-default'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/credit-cards/{id}/set-default'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreditCardAsDefault.paramsOrder = [{ type: 'parameters' }];
export const isCreditCardLimitReached = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/credit-cards/limit-reached';
    const pathInternal = '/api/credit-cards/limit-reached';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isCreditCardLimitReached.paramsOrder = [];
export const getDocumentsByEntity = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.entityId === undefined) {
        throw new Error('Missing required parameter: entityId');
    }
    if (params.entityType === undefined) {
        throw new Error('Missing required parameter: entityType');
    }
    if (params.documentCategory === undefined) {
        throw new Error('Missing required parameter: documentCategory');
    }
    const path = '/api/ws-selfbooking/documents';
    const pathInternal = '/api/documents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.entityId !== undefined) {
        urlParams.append('entityId', params.entityId.toString());
    }
    if (params.entityType !== undefined) {
        urlParams.append('entityType', params.entityType.toString());
    }
    if (params.documentCategory !== undefined) {
        urlParams.append('documentCategory', params.documentCategory.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDocumentsByEntity.paramsOrder = [{ type: 'parameters' }];
/** Create document */ export const createDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/documents';
    const pathInternal = '/api/documents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDocument.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const deleteDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/documents/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/documents/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns the Document in Base64 format. */ export const downloadDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/documents/{id}/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/documents/{id}/download'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDocument.paramsOrder = [{ type: 'parameters' }];
/** Get filtered screenshot campaigns */ export const getScreenshotCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/screenshot-campaigns';
    const pathInternal = '/api/screenshot-campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Get filtered screenshot campaign positions count */ export const getScreenshotCampaignPositionsCount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/screenshot-campaigns/positions-count';
    const pathInternal = '/api/screenshot-campaigns/positions-count';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotCampaignPositionsCount.paramsOrder = [{ type: 'parameters' }];
/** Returns screenshots by campaign id */ export const getScreenshotsByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{id}/screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/screenshot-campaigns/{id}/screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotsByCampaignId.paramsOrder = [{ type: 'parameters' }];
/** Get email template */ export const getScreenshotsEmailTemplateDto = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{campaignId}/email-template'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/screenshot-campaigns/{campaignId}/email-template'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotsEmailTemplateDto.paramsOrder = [{ type: 'parameters' }];
/** Send screenshots email */ export const sendScreenshotsEmail = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{campaignId}/send'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/screenshot-campaigns/{campaignId}/send'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
sendScreenshotsEmail.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Hide screenshot campaign positions */ export const hideScreenshotCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/hide';
    const pathInternal = '/api/screenshot-campaigns/hide';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
hideScreenshotCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
/** Unhide screenshot campaign positions */ export const unhideScreenshotCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/unhide';
    const pathInternal = '/api/screenshot-campaigns/unhide';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
unhideScreenshotCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
/** Returns archive with screenshots by selected campaign */ export const downloadScreenshotsArchive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{id}/download-screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/screenshot-campaigns/{id}/download-screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: { 200: 'blob', 204: 'void' },
        requestType: 'json',
    });
};
downloadScreenshotsArchive.paramsOrder = [{ type: 'parameters' }];
/** Add screenshots to campaign position */ export const addCampaignPositionScreenshots = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addCampaignPositionScreenshots.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete all screenshots from campaign position */ export const deleteCampaignPositionScreenshots = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/screenshots'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPositionScreenshots.paramsOrder = [{ type: 'parameters' }];
/** Delete single screenshot from campaign position */ export const deleteCampaignPositionScreenshotFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots/{fileId}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{fileId}', () => encodeURIComponent(String(params.fileId)));
    const pathInternal = '/api/campaign-positions/{id}/screenshots/{fileId}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{fileId}', () => encodeURIComponent(String(params.fileId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPositionScreenshotFile.paramsOrder = [{ type: 'parameters' }];
/** Upload a screenshot file for a campaign position */ export const uploadCampaignPositionScreenshot = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots/upload'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/campaign-positions/{id}/screenshots/upload'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadCampaignPositionScreenshot.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Get screenshot file by id */ export const downloadScreenshot = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-selfbooking/screenshots/download';
    const pathInternal = '/api/screenshots/download';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileId !== undefined) {
        urlParams.append('fileId', params.fileId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadScreenshot.paramsOrder = [{ type: 'parameters' }];
/** Get screenshot file by id and name */ export const previewScreenshotByName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-selfbooking/screenshots/preview/{fileId}/{name}'
        .replaceAll('{fileId}', () => encodeURIComponent(String(params.fileId)))
        .replaceAll('{name}', () => encodeURIComponent(String(params.name)));
    const pathInternal = '/api/screenshots/preview/{fileId}/{name}'
        .replaceAll('{fileId}', () => encodeURIComponent(String(params.fileId)))
        .replaceAll('{name}', () => encodeURIComponent(String(params.name)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
previewScreenshotByName.paramsOrder = [{ type: 'parameters' }];
/** Get payments */ export const getPayments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/payments';
    const pathInternal = '/api/payments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyIds : (params.companyIds ?? queryDefaults?.['companyIds']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('companyIds', item.toString()));
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterByPayoutDate
            : (params.filterByPayoutDate ?? queryDefaults?.['filterByPayoutDate']);
        if (value !== undefined) {
            urlParams.append('filterByPayoutDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeUnsuccessful
            : (params.includeUnsuccessful ?? queryDefaults?.['includeUnsuccessful']);
        if (value !== undefined) {
            urlParams.append('includeUnsuccessful', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.requireApproval : (params.requireApproval ?? queryDefaults?.['requireApproval']);
        if (value !== undefined) {
            urlParams.append('requireApproval', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayments.paramsOrder = [{ type: 'parameters' }];
/** Get payments by campaign ID */ export const getPaymentsByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/payments/by-campaign';
    const pathInternal = '/api/payments/by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaymentsByCampaign.paramsOrder = [{ type: 'parameters' }];
/** Charge a payment that is pending manual approval */ export const chargePayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/payments/{id}/charge'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/payments/{id}/charge'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
chargePayment.paramsOrder = [{ type: 'parameters' }];
/** Get payouts */ export const getPayouts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/payouts';
    const pathInternal = '/api/payouts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayouts.paramsOrder = [{ type: 'parameters' }];
/** Download payouts archive */ export const downloadPayoutsArchive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/payouts/{id}/archive'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/payouts/{id}/archive'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPayoutsArchive.paramsOrder = [{ type: 'parameters' }];
/** Get invoices */ export const getInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/invoices';
    const pathInternal = '/api/invoices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.state : (params.state ?? queryDefaults?.['state']);
        if (value !== undefined) {
            urlParams.append('state', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.unpaid : (params.unpaid ?? queryDefaults?.['unpaid']);
        if (value !== undefined) {
            urlParams.append('unpaid', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoices.paramsOrder = [{ type: 'parameters' }];
/** Returns all invoices that match provided ids */ export const getInvoicesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-selfbooking/invoices/by-ids';
    const pathInternal = '/api/invoices/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoicesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
/** Returns a single invoice by id */ export const getInvoiceById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/invoices/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/invoices/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceById.paramsOrder = [{ type: 'parameters' }];
/** Reverts a PAID invoice back to the state derived from its invoicedAt */ export const revokePaidStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/revoke-paid'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/invoices/{id}/revoke-paid'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
revokePaidStatus.paramsOrder = [{ type: 'parameters' }];
/** Updating Invoice state to given one with sending email */ export const updateInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/state'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/invoices/{id}/state'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateInvoiceState.paramsOrder = [{ type: 'parameters' }];
/** Updating Invoice state to CHARGED with sending email */ export const chargeInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/charge'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/invoices/{id}/charge'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
chargeInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Build invoice email template form */ export const getSendInvoiceDocumentTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/template'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/invoices/{id}/template'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSendInvoiceDocumentTemplate.paramsOrder = [{ type: 'parameters' }];
/** Sending Invoice email without updating state */ export const sendInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/send'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/invoices/{id}/send'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
sendInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get companies referenced by entities of the given type, as data for the company filter */ export const getCompaniesByFilterType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filterType === undefined) {
        throw new Error('Missing required parameter: filterType');
    }
    const path = '/api/ws-selfbooking/companies';
    const pathInternal = '/api/companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filterType !== undefined) {
        urlParams.append('filterType', params.filterType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompaniesByFilterType.paramsOrder = [{ type: 'parameters' }];
/** Get balance for current company */ export const getCompanyBalance = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/company/balance';
    const pathInternal = '/api/company/balance';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyBalance.paramsOrder = [];
/** Top up company balance */ export const topUpCompanyBalance = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/company/balance/top-up';
    const pathInternal = '/api/company/balance/top-up';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
topUpCompanyBalance.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get balance activities for current company */ export const getBalanceActivities = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-selfbooking/balance-activities';
    const pathInternal = '/api/balance-activities';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBalanceActivities.paramsOrder = [{ type: 'parameters' }];
/** Get balance activities for selected campaign */ export const getBalanceActivitiesByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/balance-activities/by-campaign';
    const pathInternal = '/api/balance-activities/by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBalanceActivitiesByCampaign.paramsOrder = [{ type: 'parameters' }];
/** Get publishers */ export const getPublishers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    const path = '/api/ws-selfbooking/publishers';
    const pathInternal = '/api/publishers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublishers.paramsOrder = [{ type: 'parameters' }];
/** Returns all publishers that match provided ids */ export const getPublishersByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-selfbooking/publishers/by-ids';
    const pathInternal = '/api/publishers/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublishersByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
/** Get activities by campaign ID */ export const getActivitiesByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/activities/by-campaign';
    const pathInternal = '/api/activities/by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getActivitiesByCampaign.paramsOrder = [{ type: 'parameters' }];
/** Returns dashboard statistics for the campaign overview, key performance metrics and campaign status overview blocks */ export const getDashboardStatistics = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/statistics';
    const pathInternal = '/api/dashboard/statistics';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardStatistics.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Returns the top creatives (by delivered impressions) for the dashboard */ export const getDashboardTopCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/top-creatives';
    const pathInternal = '/api/dashboard/top-creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardTopCreatives.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns the top publishers (websites, by delivered impressions) for the dashboard */ export const getDashboardTopPublishers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/top-publishers';
    const pathInternal = '/api/dashboard/top-publishers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardTopPublishers.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns the key performance metrics (monthly chart) as a CSV report */ export const getDashboardKeyPerformanceMetricsReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/key-performance-metrics/report';
    const pathInternal = '/api/dashboard/key-performance-metrics/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardKeyPerformanceMetricsReport.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Returns the expenses block as a CSV report */ export const getDashboardExpensesReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/expenses/report';
    const pathInternal = '/api/dashboard/expenses/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardExpensesReport.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Returns the campaign status overview block as a CSV report */ export const getDashboardStatusOverviewReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/status-overview/report';
    const pathInternal = '/api/dashboard/status-overview/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardStatusOverviewReport.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Returns the top creatives block as a CSV report */ export const getDashboardTopCreativesReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/top-creatives/report';
    const pathInternal = '/api/dashboard/top-creatives/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardTopCreativesReport.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns the top publishers block as a CSV report */ export const getDashboardTopPublishersReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/top-publishers/report';
    const pathInternal = '/api/dashboard/top-publishers/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardTopPublishersReport.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns the campaigns comparative analytics block as a CSV report */ export const getDashboardCampaignsAnalyticsReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/campaigns-analytics/report';
    const pathInternal = '/api/dashboard/campaigns-analytics/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardCampaignsAnalyticsReport.paramsOrder = [
    { type: 'body', paramName: 'form' },
    { type: 'parameters' },
];
/** Returns the positions comparative analytics block as a CSV report */ export const getDashboardPositionsAnalyticsReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/positions-analytics/report';
    const pathInternal = '/api/dashboard/positions-analytics/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardPositionsAnalyticsReport.paramsOrder = [
    { type: 'body', paramName: 'form' },
    { type: 'parameters' },
];
/** Returns all dashboard blocks as one xlsx report with a sheet per dashboard card */ export const getDashboardReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/dashboard/report';
    const pathInternal = '/api/dashboard/report';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDashboardReport.paramsOrder = [{ type: 'body', paramName: 'form' }];
export * from './types';
export * from './constants';
